import { View } from "react-native-ui-lib";

export const LocalPendingSalesList = () => {
  return <View />;
};
